import React from 'react';
import { Languages } from '../Enums/Common';
import { InitialTabParams } from '../Modules/Patient/Interfaces/InitialTabParams.interface';

const AppContext = React.createContext<any>({
	translation: [],
	globalTemplate: 'default',
});

interface AppContextUserData {
	id: string;
	workplaceId: string;
}

interface AclData {
	loading: boolean;
	data: any;
	listeners: (() => void)[];
	fireListeners: () => void;
}

interface StaticLinks {
	assets: {
		profile: string;
	};
	treatment: {
		prescriptionModal: string;
		duplicatePrescription: string;
		planNewQuestionnaire: string;
		editQuestionnairePlanning: string;
		questionnaireStatistics: string;
		downloadPrescription: string;
		downloadPrescriptionSukl: string;
	};
}

interface AppContextProps {
	socketUrl: string;
	userData: AppContextUserData;
	language: Languages;
	currency: string;
	vatRate: number;
	phonePrefix: string;
	loggedUserId: string;
	workplaceId: string;
	globalTemplate: string;
	translation: { [key: string]: string };
	dateFormat: string;
	dateFormatMoment: string;
	isLatam: boolean;
	isMou: boolean;
	isTherapist?: boolean;
	isSUKLAllowed?: boolean;
	aclData: AclData;
	links: StaticLinks;
	redirectCaseList: string;
	redirectArchive: string;
	socket: {
		on: (event: string, callback: (data: any) => void) => void;
		off: (event: string, callback: (data: any) => void) => void;
	};
	redirectManagerCaseTypes: string;
	redirectToOnlineOrdering: string;
	redirectToServiceSchedule: string;
	redirectToUserCertificates: string;
	openMouRegistration: string;
	changeWorkPlace: string;
	defaultTimeZone: string;
	partner: number;
	partnerId: number;
	redirectLoginPage: string;
	activeTab?: string;
	activeTabParams?: InitialTabParams;
	isSplitPaymentSupported: boolean;
	isProduction: boolean;
}

export function AppContextProvider(props: any) {
	// @ts-ignore
	let dateFormat = MeddiApp.dateFormat;
	if (dateFormat === 'd.m.Y') {
		dateFormat = 'dd.MM.yyyy';
	}

	let dateFormatMoment = 'DD.MM.YYYY';
	let isLatam = false;
	// @ts-ignore
	switch (MeddiApp.globalTemplate) {
		case 'peru':
		case 'ecuador':
		case 'mexico':
		case 'colombia':
			isLatam = true;
			dateFormatMoment = 'DD/MM/YYYY';
	}

	// @ts-ignore
	return (
		<AppContext.Provider
			value={{
				...props,
				// @ts-ignore
				socketUrl: MeddiApp.socketUrl,
				// @ts-ignore
				userData: MeddiApp.userData,
				// @ts-ignore
				apiUrl: MeddiApp.socketUrl,
				// @ts-ignore
				accessToken: MeddiApp.accessToken,
				// @ts-ignore
				language: MeddiApp.language,
				// @ts-ignore
				dateFormat: dateFormat,
				// @ts-ignore
				currency: MeddiApp.currency,
				// @ts-ignore
				phonePrefix: MeddiApp.phonePrefix,
				// @ts-ignore
				vatRate: MeddiApp.vatRate,
				// @ts-ignore
				loggedUserId: MeddiApp.loggedUserId,
				// @ts-ignore
				links: MeddiApp.links,
				// @ts-ignore
				partner: MeddiApp.partner,
				// @ts-ignore
				translation: jsTranslation,
				// @ts-ignore
				workplaceId: MeddiApp.workplaceId,
				// @ts-ignore
				socket: MeddiApp.actualCase.socket,
				// @ts-ignore
				notification: MeddiApp.notification,
				// @ts-ignore
				globalTemplate: MeddiApp.globalTemplate,
				// @ts-ignore
				aclData: MeddiApp.aclData,
				// @ts-ignore
				partnerId: MeddiApp.partnerId,
				// @ts-ignore
				isMou: !!MeddiApp.isMou,
				// @ts-ignore
				defaultTimeZone: MeddiApp.defaultTimeZone,
				// @ts-ignore
				isSplitPaymentSupported: MeddiApp.allowSplitPayment,
				// @ts-ignore
				isProduction: MeddiApp.isProduction,
				isLatam,
				dateFormatMoment,
			}}>
			{props.children}
		</AppContext.Provider>
	);
}

export const useAppContext = (): AppContextProps =>
	React.useContext(AppContext);
